import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import Loader from "./Loader";
import {IAuditLog, IAxiosGetResponse} from "../../../interfaces/IUtilities";
import {getAll} from "../../../pages/_request";
import {NavLink, useNavigate} from "react-router-dom";
import {useToast} from "./ToastContext";
import {AuditActionTypeEnumText, AuditEntityTypeEnumText} from "../../../helpers/EnumeratorHelper";
import {formatDateTime} from "../../../helpers/DateTimeHelper";


const AuditLogsPanel: React.FC<{}> = () => {

    const {t} = useTranslation();
    const navigate = useNavigate();

    const [auditLogs, setAuditLogs] = useState([] as IAuditLog[]);
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const pageSize = 10;
    const { showToast } = useToast();

    // Simulated API call
    const fetchLatestAuditLogs = async (pageNumber = 1, pageSize = 10) => {
        try {
            let result = await getAll("/api/auditlogs/latest", '');
            let respStatus = result?.status || result?.response?.status;

            if (respStatus === 200) {
                setAuditLogs(result.data.items as IAuditLog[]);
                setVisible(true);
                setLoading(false);
            }
            else if (respStatus === 403) {
                //navigate("/error/403");
                showToast(t('ForbidViewActionForLogs'), 'warning');
            }
            else if (respStatus === 401) {
                navigate("/auth/login");
            }
            else if (respStatus === 500) {
                navigate("/error/500");
            }
            else {
                throw new Error(t('StatusCode', {code: String(respStatus)}));
            }
        } catch (error) {
            setLoading(false);
            console.log(t('ConnectionError', {error: String(error)})); 
        }
    };

    useEffect(() => {
        fetchLatestAuditLogs();
    }, [page, pageSize]);

    return (
        <>
        {visible ?
            <div className="audit-logs">
                <div className="mb-4">
                    <h5 className="audit-logs__title h6 p-2 mb-0 border">
                        { t('LatestLogs') }</h5>
                    {loading ? <Loader/> : <>
                        <table className="table table-bordered table-sm table-striped text-start w-full table-logs">
                            <thead>
                            <tr>
                                <th className="p-1 text-left text-nowrap">{ t('ActionType') }</th>
                                <th className="p-1 text-left text-nowrap">{ t('EntityType')}</th>
                                <th className="p-1 text-left text-nowrap">{ t('IpAddress')}</th>
                                <th className="p-1 text-left text-nowrap">{ t('Timestamp')}</th>
                                <th className="p-1 text-left text-nowrap"></th>
                            </tr>
                            </thead>
                            <tbody>
                            {auditLogs.map((log, index) => (
                                <tr key={index}
                                    className={'table-logs__item ' + (log.errorMsg ? 'table-logs__item--error' : '')}>
                                    <td>{AuditActionTypeEnumText[log.actionType]}</td>
                                    <td>{AuditEntityTypeEnumText[log.entityType]}</td>
                                    <td>{log.ipAddress}</td>
                                    <td className="text-nowrap">{formatDateTime(log.timestamp)}</td>
                                    <td>
                                        <NavLink to={'/audit-logs/details/' + log.auditId}>{ t('Details')}</NavLink>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        <NavLink to='/audit-logs/list' className="btn gg-btn-submit btn-sm">{ t('SeeMore')}</NavLink>
                    </>}
                </div>
            </div>
            : <></>}
        </>
    )
}
export default AuditLogsPanel;